<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Relatório de Movimento Financeiro Mensal</h1>
    <span *ngIf="carregado" class="badge bg-secondary">Total: {{ movimentos.length }}</span>
  </div>
  <hr />

  <!-- Filtros -->
  <div class="row g-2 align-items-end mb-3 no-print">
    <div class="col-md-3">
      <label class="form-label">Período Inicial <span class="text-danger">*</span></label>
      <input type="month" class="form-control campo-obrigatorio" required
             [class.is-invalid]="periodoInicialInvalido"
             [(ngModel)]="periodoInicial" />
      <div class="invalid-feedback" *ngIf="periodoInicialInvalido">
        Informe o período inicial.
      </div>
    </div>
    <div class="col-md-3">
      <label class="form-label">Período Final <span class="text-danger">*</span></label>
      <input type="month" class="form-control campo-obrigatorio" required
             [class.is-invalid]="periodoFinalInvalido"
             [(ngModel)]="periodoFinal" />
      <div class="invalid-feedback" *ngIf="periodoFinalInvalido">
        Informe o período final.
      </div>
    </div>
    <div class="col-md-3 ms-md-auto d-flex gap-2">
      <button class="btn btn-primary w-100" (click)="buscar()" [disabled]="carregando">
        <span *ngIf="carregando" class="spinner-border spinner-border-sm me-1"></span>
        Buscar
      </button>
      <button class="btn btn-outline-secondary w-100" (click)="limpar()" [disabled]="carregando">
        Limpar
      </button>
    </div>
  </div>

  <div class="alert alert-warning no-print mb-3"
       *ngIf="tentouBuscar && (!periodoInicial || !periodoFinal)">
    Informe o período inicial e o período final para gerar o relatório.
  </div>

  <div *ngIf="carregando" class="alert alert-info no-print" role="alert">
    Carregando relatório...
  </div>

  <!-- Resultados -->
  <div *ngIf="carregado">

    <div class="d-flex justify-content-end mb-2 no-print">
      <button class="btn btn-outline-dark btn-sm" (click)="imprimir()">Imprimir Relatório</button>
    </div>

    <!-- Cabeçalho visível apenas na impressão -->
    <div class="print-header print-only">
      <div class="print-header-title">Relatório de Movimento Financeiro Mensal</div>
      <div class="print-header-meta">
        <span>
          Período: {{ formatPeriodo(periodoInicial) }} a {{ formatPeriodo(periodoFinal) }}
        </span>
        <span class="print-header-sep"> | Total: {{ movimentos.length }} mês(es)</span>
        <span class="print-header-sep"> | Gerado em: {{ dataGeracao }}</span>
      </div>
      <div class="print-header-divider"></div>
    </div>

    <div *ngIf="movimentos.length === 0" class="text-center text-muted py-4">
      Nenhum movimento encontrado para o período selecionado.
    </div>

    <div class="table-responsive" *ngIf="movimentos.length > 0">
      <table class="table table-striped table-hover print-table">
        <thead class="table-dark">
          <tr>
            <th scope="col">Mês</th>
            <th scope="col" class="text-end">Faturado</th>
            <th scope="col" class="text-end">Entradas</th>
            <th scope="col" class="text-end">Saídas</th>
            <th scope="col" class="text-end">Saldo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of movimentos">
            <td>{{ mov.label }}</td>
            <td class="text-end">{{ mov.totalFaturado | currency:'BRL' }}</td>
            <td class="text-end text-success">{{ mov.totalEntradas | currency:'BRL' }}</td>
            <td class="text-end text-danger">{{ mov.totalSaidas | currency:'BRL' }}</td>
            <td class="text-end fw-bold"
                [class.text-primary]="mov.saldo >= 0"
                [class.text-danger]="mov.saldo < 0">
              {{ mov.saldo | currency:'BRL' }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="print-totals">
            <td class="text-end fw-bold">Totais:</td>
            <td class="text-end fw-bold">{{ totalFaturado | currency:'BRL' }}</td>
            <td class="text-end fw-bold">{{ totalEntradas | currency:'BRL' }}</td>
            <td class="text-end fw-bold">{{ totalSaidas | currency:'BRL' }}</td>
            <td class="text-end fw-bold"
                [class.text-primary]="saldoTotal >= 0"
                [class.text-danger]="saldoTotal < 0">
              {{ saldoTotal | currency:'BRL' }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>
